"use client"

import { TrustBadges } from "@shared/ui/landing/trust-badges"
import { Separator } from "@shared/ui/components/separator"

import { useTranslations } from "@/lib/i18n/client"

export function SiteFooter() {
  const t = useTranslations("footer")
  const tCommon = useTranslations("common")

  const columns = [
    {
      title: t("product"),
      links: [
        { href: "#scan", label: t("scanEngine") },
        { href: "#risks", label: t("riskMatrix") },
        { href: "#report", label: t("reports") },
      ],
    },
  ] as const

  return (
    <footer className="border-t border-white/10 bg-black/40">
      <div className="mx-auto max-w-6xl px-4 py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-4">
            <p className="text-lg font-semibold">{tCommon("appName")}</p>
            <p className="text-sm text-muted-foreground">{t("tagline")}</p>
            <TrustBadges
              labels={{
                verified: t("verified"),
                ssl: t("ssl"),
                encryption: t("encryption"),
              }}
            />
          </div>
          {columns.map((column) => (
            <div key={column.title} className="space-y-3">
              <p className="text-sm font-medium">{column.title}</p>
              <ul className="space-y-2 text-sm text-muted-foreground">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="hover:text-foreground">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <Separator className="my-10 bg-white/10" />
        <div className="flex flex-col gap-2 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p>{t("copyright", { year: new Date().getFullYear() })}</p>
          <p>{t("disclaimer")}</p>
        </div>
      </div>
    </footer>
  )
}
